
const styles = {
  cell: {
    padding: "5px",
    textAlign: "center",
    fontSize: "12px !important",
  },
  cellSmall: {
padding: "5px",
    textAlign: "center",
    fontSize: "12px !important",
    width: "6% !important"
  },
  input: {
    height: "unset",
    border: "none",
    backgroundColor: "transparent",
    fontSize: "12px",
    textAlign: "center"
  },
  button: {
    fontWeight: "bold",
    padding: "5px 20px",
    width: "15vw",
    height: "40px"
  },
  formInput: {
    fontSize: "16px",
    height: "40px",
    padding: "10px",
  },
  natpis: { fontWeight: "bold", fontSize: "16px", marginBottom: "5px"},
  
};

export default styles;
